module.exports = __webpack_public_path__ + "static/drupal-d6c63ad2513f87d3889f81363e4b9ee4.png";